export const InventorySuppliers = {
  en: {
    Suppliers: 'Suppliers',
    'Create Supplier': 'Create Supplier',
    Phone: 'Phone',
    'Registration Code': 'EDRPOU / RNOKPP',
    'Settlement Balance': 'Settlement balance',
  },
  uk: {
    Suppliers: 'Постачальники',
    'Create Supplier': 'Створити постачальника',
    Phone: 'Телефон',
    'Registration Code': 'ЄДРПОУ / РНОКПП',
    'Settlement Balance': 'Баланс розрахунків',
  },
};

export const InventorySupplierForm = {
  en: {
    ...InventorySuppliers.en,
    'New Supplier': 'New Supplier',
    'Edit Supplier': 'Edit Supplier',
    'Update Supplier': 'Update Supplier',
    Information: 'Information',
    'Legal Entity Type': 'Legal form',
    'E-mail': 'E-mail',
    Website: 'Website',
    Notes: 'Notes',
    'Contact Persons': 'Contact persons',
    'Contact Person': 'Contact person',
    'Add Contact Person': 'Add contact person',
    'Remove Contact Person': 'Remove contact person',
    'Last Name': 'Last name',
    'First Name': 'First name',
    'Middle Name': 'Middle name',
    'Job Title': 'Job title',
    'Contact name required': 'Enter a first name or a last name',
    Requisites: 'Requisites',
    'Legal Address': 'Legal address',
    'Actual address differs': 'Actual address differs',
    'Actual Address': 'Actual address',
    address_postcode: 'Postcode',
    address_city: 'City',
    address_street: 'Street',
    address_building: 'Building',
    address_office: 'Office',
    'Registration Code hint':
      '8 digits for a company (EDRPOU) or 10 digits for an individual entrepreneur (RNOKPP).',
    'VAT Payer': 'VAT payer',
    'VAT Number': 'VAT number (IPN)',
    IBAN: 'IBAN',
    'IBAN hint': 'Ukrainian account number: UA and 27 digits.',
    'Bank Name': 'Bank name',
    'Settlements with the supplier': 'Settlements with the supplier',
    'Opening Balance': 'Opening balance',
    'Opening Balance hint':
      'What was owed when the supplier was added: negative if you owe the supplier, positive if the supplier owes you. It cannot be changed after the first settlement operation.',
    'Changed only by operations': 'changed only by operations',
  },
  uk: {
    ...InventorySuppliers.uk,
    'New Supplier': 'Новий постачальник',
    'Edit Supplier': 'Редагування постачальника',
    'Update Supplier': 'Оновити постачальника',
    Information: 'Інформація',
    'Legal Entity Type': 'Правова форма',
    'E-mail': 'E-mail',
    Website: 'Вебсайт',
    Notes: 'Нотатки',
    'Contact Persons': 'Контактні особи',
    'Contact Person': 'Контактна особа',
    'Add Contact Person': 'Додати контактну особу',
    'Remove Contact Person': 'Видалити контактну особу',
    'Last Name': 'Прізвище',
    'First Name': "Ім'я",
    'Middle Name': 'По батькові',
    'Job Title': 'Посада',
    'Contact name required': "Вкажіть ім'я або прізвище",
    Requisites: 'Реквізити',
    'Legal Address': 'Юридична адреса',
    'Actual address differs': 'Фактична адреса відрізняється',
    'Actual Address': 'Фактична адреса',
    address_postcode: 'Індекс',
    address_city: 'Місто',
    address_street: 'Вулиця',
    address_building: 'Будинок',
    address_office: 'Офіс',
    'Registration Code hint':
      '8 цифр для юридичної особи (ЄДРПОУ) або 10 цифр для ФОП (РНОКПП).',
    'VAT Payer': 'Платник ПДВ',
    'VAT Number': 'ІПН',
    IBAN: 'IBAN',
    'IBAN hint': 'Номер рахунку: UA та 27 цифр.',
    'Bank Name': 'Назва банку',
    'Settlements with the supplier': 'Розрахунки з постачальником',
    'Opening Balance': 'Початковий баланс',
    'Opening Balance hint':
      'Скільки було винно на момент додавання постачальника: відʼємне значення — ви винні постачальнику, додатне — постачальник винен вам. Після першої операції розрахунків змінити не можна.',
    'Changed only by operations': 'змінюється лише операціями',
  },
};
